document.addEventListener("DOMContentLoaded", function () {
  const productSlideEl = document.querySelector(".productSlide");
  if (!productSlideEl) return;

  const swiper = new Swiper(productSlideEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    rewind: true,
    allowTouchMove: true,
    simulateTouch: true,
    mousewheel: {
      forceToAxis: true,
      thresholdDelta: 50,
    },
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next3",
      prevEl: ".swiper-button-prev3",
    },
  });

  const progress = document.querySelector(".slide-progress");

  if (progress) {
    swiper.on("slideChange", function () {
      progress.style.setProperty("--slide-index", swiper.activeIndex);
    });
  }

  window.addEventListener("load", () => swiper.update(), { once: true });
});
